import styled from '@emotion/styled';

import { IconButton } from '../../../../IconButton';

const SidebarToggle = styled(IconButton)({
  marginLeft: -9,
});

export const S = {
  SidebarToggle,
} as const;
